import { Component, OnInit } from '@angular/core';
import { ManagedLinkKey } from 'src/common/managedLinkKey';

@Component({
	selector: 'mesa-ayuda',
	templateUrl: './mesa-ayuda.component.html',
	styleUrls: ['./mesa-ayuda.component.scss']
})
export class MesaAyudaComponent implements OnInit {

	cardsConfig = [
		{
			title: "Sistemas Informáticos",
			class: "sistemas-informaticos",
			desc: "Solicite y registre una solicitud de servicio, de soporte, incidencias y/o interrupciones de servicio y cualquier otra necesidad informática.",
			links: [
				{ text: "Solicitar ayuda", url: ManagedLinkKey.MA_SIST_INFO_SOLICITAR_AYUDA },
				{ text: "Estado actual de solicitud", url: ManagedLinkKey.MA_SIST_INFO_ESTADO }
			]
		},
		{
			title: "Empadronamiento",
			class: "empadronamiento",
			desc: "Solicite la modificación sobre los datos de un paciente o persona empadronada.",
			links: [
				{ text: "Solicitar modificación", url: ManagedLinkKey.MA_EMP_SOLICITAR_MODIFCACION },
				{ text: "Estado actual de solicitud", url: ManagedLinkKey.MA_EMP_ESTADO }
			]
		},
		{
			title: "Recursos Humanos",
			class: "recursos-humanos",
			desc: "Genere solicitudes relacionadas a gestión de vacaciones, liquidación de sueldo, ausentismo, beneficios, etc.",
			links: [
				{ text: "Solicitar ayuda", url: ManagedLinkKey.MA_RRHH_SOLICITAR_AYUDA },
				{ text: "Estado actual de solicitud", url: ManagedLinkKey.MA_RRHH_ESTADO}
			]
		},
		{
			title: "Ingeniería de Planta",
			class: "ingenieria-planta",
			desc: "Solicite pedidos de mantenimiento edilicio, equipamiento y protección hospitalaria. Descargue instructivos y planos del Hospital Central y San Justo.",
			links: [
				{ text: "Solicitar ayuda", url: ManagedLinkKey.MA_ING_PLANTA_SOLICITAR_AYUDA },
				{ text: "Norma", url: ManagedLinkKey.MA_ING_PLANTA_NORMA },
				{ text: "Instructivo de Sede Central", url: ManagedLinkKey.MA_ING_PLANTA_INSTRUCTIVO_CENTRAL },
				{ text: "Instructivo de Sede San Justo", url: ManagedLinkKey.MA_ING_PLANTA_INSTRUCTIVO_SAN_JUSTO },
				{ text: "Plano de Sede Central", url: ManagedLinkKey.MA_ING_PLANTA_PLANO_CENTRAL },
				{ text: "Plano de Sede San Justo", url: ManagedLinkKey.MA_ING_PLANTA_PLANO_SAN_JUSTO }
			]
		},
		{
			title: "Comunicación",
			class: "noticias",
			desc: "Podés solicitar la suba de una nota en Comunitá o pedir cambios en la web o micrositios de servicios.",
			links: [
				{ text: "Solicitar alta de noticia en Comunità", url: ManagedLinkKey.MA_NOTI_SOLICITAR_ALTA_NOTICIA },
				{ text: "Solicitar cambios en la Web o micrositio", url: ManagedLinkKey.MA_NOTI_SOLICITAR_CAMBIOS },
				{ text: "Estado actual de solicitud de noticia en Comunità", url: ManagedLinkKey.MA_NOTI_VER_ESTADO },
				{ text: "Estado actual de cambios en la Web o micrositio", url: ManagedLinkKey.MA_NOTI_VER_ESTADO_CAMBIOS }
			]
		},
		{
			title: "Nuevo Equipamiento",
			class: "equipamiento",
			desc: "Solicite nuevo equipamiento informático (PCs, monitores, licencias), en el caso de ser Jefe de Dpto., de Área o de Servicio.",
			links: [
				{ text: "Solicitar equipamiento", url: ManagedLinkKey.MA_NUEVO_EQUIP_SOLICITAR },
				{ text: "Estado actual de solicitud", url: ManagedLinkKey.MA_NUEVO_EQUIP_ESTADO }
			]
		},
		{
			title: "Gerencia Comercial",
			class: "gerencia-comercial",
			desc: "Genere solicitudes para inconvenientes con modalidad operativa, presupuestos, autorizaciones de entidades, problemas de conectividad, alta de usuarios a web de entidades y/o cualquier otra consulta a Gerencia Comercial.",
			links: [
				{ text: "Solicitar pedido", url: ManagedLinkKey.MA_GERENCIA_COMERCIAL_SOLICITAR },
				{ text: "Estado actual de solicitud", url: ManagedLinkKey.MA_GERENCIA_COMERCIAL_ESTADO }
			]
		},
		{
			title: "Gestión de Implantes",
			class: "gestion-implantes",
			desc: "Genere una solicitud para los pacientes que sean intervenidos quirúrgicamente por el servicio de ortopedia y requieran la gestión de implantes.",
			links: [
				{ text: "Solicitar pedido", url: ManagedLinkKey.MA_GESTION_IMPLANTES_SOLICITAR },
				{ text: "Estado actual de solicitud", url: ManagedLinkKey.MA_GESTION_IMPLANTES_ESTADO }
			]
		}
	];

	constructor() {
	}

	ngOnInit() {
	}

}
